import axios from 'axios'

import {urlDomain } from '../config/constant'

const apiDomain = urlDomain();

// glUsrDataViaEmail
export const glUsrDataViaEmail  = (empid, ak, inputParam ) =>{
  if(ak){
     const apiUrl = `${apiDomain}/glUsrDataViaEmail?empid=${empid}&AK=${ak}${inputParam}`;
     return axios.get(apiUrl)
   }
}

// companydetailnew
export const companydetailnew  = (empid, ak, keyword ) =>{
  if(ak){
    const apiUrl = `${apiDomain}/companydetailnew?empid=${empid}&all=all&MODID=9696&screen_name=9696&AK=${ak}&keyword=${keyword}`;
    return axios.get(apiUrl)
  }
}

export const invoiceLink =(empid,ak,glid,invoice_id)=>{
  const apiUrl = `${apiDomain}/InvoiceHTMLReturn?glid=${glid}&invoiceId=${invoice_id}&empId=${empid}&other=1&AK=${ak}&modid=9696`
  return axios.get(apiUrl)
}

// Service Tab Details
export const getServiceDetails = (empid, ak, glid) => {
  const apiUrl = `${apiDomain}/getServiceDetails?empid=${empid}&modid=9696&glid=${glid}&AK=${ak}&activeAndPast=1`;
  return axios.get(apiUrl)
}

// Cached wrapper — first caller fetches; concurrent/subsequent callers for the same
// glid share the in-flight promise or get the cached payload directly.
// Returns the unwrapped data payload (response.data.data), or null on failure.
const _svcDetailsCache = new Map();    // glid → data payload
const _svcDetailsInFlight = new Map(); // glid → Promise<data payload>

export const getServiceDetailsCached = async (empid, ak, glid) => {
  if (_svcDetailsCache.has(glid)) return _svcDetailsCache.get(glid);

  if (!_svcDetailsInFlight.has(glid)) {
    const promise = getServiceDetails(empid, ak, glid)
      .then(response => {
        if (response?.data?.status === 200) {
          const data = response.data.data;
          _svcDetailsCache.set(glid, data);
          return data;
        }
        return null;
      })
      .catch(() => null)
      .finally(() => _svcDetailsInFlight.delete(glid));
    _svcDetailsInFlight.set(glid, promise);
  }

  return _svcDetailsInFlight.get(glid);
};

// Call dispostions (Buyer, Suppier, User)
export const getDispositions = (empid, ak, conditon) =>{
  const apiUrl = `${apiDomain}/getDispositions?empid=${empid}&AK=${ak}&modid=9696&${conditon}`
  return axios.get(apiUrl)
}

// employeedetails
export const employeedetails = (empid, ak) =>{
  const apiUrl = `${apiDomain}/employeedetails?empid=${empid}&AK=${ak}&modid=9696`
  return axios.get(apiUrl)
}

export const payment_history = (glid, empid, ak) => {
  let config = {
    method: 'get',
    maxBodyLength: Infinity,
    url: `${apiDomain}/payment-history?glid=${glid}&empid=${empid}&screen_name=payment_history&modid=9696`,
    headers: { 
      'Authorization': `Bearer ${ak}`
    }
  };
  
  return axios.request(config);
}

export const callhistory = (empid, ak, condition) =>{
  const url =  `${apiDomain}/callhistory?empid=${empid}&AK=${ak}&modid=9696&type=report${condition}`;
  return axios.get(url)
}


export const workorderdetails = (empid, ak, glid, check, woid) =>{
  const apiUrl = `${apiDomain}/workorderdetails?empid=${empid}&AK=${ak}&glid=${glid}&modid=9696&check=${check}&woid=${woid}`;
  return axios.get(apiUrl)
}

export const stsHistory = (empid, ak, glid, duration) =>{
  const apiurl = `${apiDomain}/newHistory?empid=${empid}&AK=${ak}&glid=${glid}&tab=history&duration=${duration}`

  return axios.get(apiurl)
}

export const ticketViewService = (empid, ak, glid, condition) =>{
  const apiurl = `${apiDomain}/tktDetails?glid=${glid}&empid=${empid}&AK=${ak}&modid=9696${condition}`;

  return axios.get(apiurl)
}

// 'tagging_check','#01'

export const taggingInChecks = (empid, ak, paid, glid) => {
  const apiurl = `${apiDomain}/taggingInChecks?empid=${empid}&userType=${paid}&AK=${ak}&glid=${glid}`;
  return axios.get(apiurl)
}

// ticketbucket #01
export const ticketBucket = (empid, ak, ticketid) => {
  const apiurl = `${apiDomain}/ticketbucket?empid=${empid}&ticketId=${ticketid}&modid=9696&AK=${ak}`;
  return axios.get(apiurl)
}

// 'ticketbucket','#02'

export const ticketUpdateCount = (empid, ak, tktId) =>{
  const apiurl = `${apiDomain}/ticketbucket?empid=${empid}&ticketId=${tktId}&modid=9696&type=u&AK=${ak}`;
  
  return axios.get(apiurl)
  
}

// getemployeeinfo
export const getemployeeinfo = (empid, ak) =>{
  const apiurl = `${apiDomain}/apiemployeedetails?modid=9696&type=1&empid=${empid}&AK=${ak}`;

  return axios.get(apiurl)
}

// BS MatchMaking API
export const bsMatchMaking = (empid, ak, glid, startDate, endDate) =>{
  const apiurl = `${apiDomain}/MatchmakingDetails?empid=${empid}&AK=${ak}&glid=${glid}&startDate=${startDate}&endDate=${endDate}`;
  return axios.get(apiurl)
}

// getSTS ID
export const getSTSID = (empid, ak, glid) =>{
  const apiUrl = `${apiDomain}/Stsoperation/insertstsdata?empid=${empid}&AK=${ak}&glid=${glid}`;
  return axios.get(apiUrl)
}

// GST Turnover
export const fetchGstTurnOverData = (empid, ak, glid) => {
  const headers = {
    Authorization: `Bearer ${ak}`,
  };
  const apiUrl = `${apiDomain}/gst-turn-over-details?&modid=9696&screen_name=9696&empid=${empid}&glids=${glid}`
  return axios.get(apiUrl, { headers })
}

// Service Vintage
export const serviceVintage = (empid, ak, glid) => {
  const apiUrl = `${apiDomain}/kycDetails?glid=${glid}&empid=${empid}&AK=${ak}&modid=9696`
  return axios.get(apiUrl)
}

export const videoCallMeeting = (empid, ak, call_hour, vertical_id, call_min, employee_arr, call_date, glid, weberp_subject, addition_email) => {
  const apiUrl = 'https://merp.intermesh.net/index.php/csd/CSDMeeting/StsNewUpdate';
  const requestData = {
    call_hour:call_hour,
    edit_tbro: false,
    chk_tbro: false,
    vertical_id: vertical_id,
    call_service_id: '',
    call_min: call_min,
    type: 'call',
    call_purpose_id: 30,
    tbro_date: '',
    platform: '9696CRM',
    send_mail_to_client: false,
    employee_arr: employee_arr,
    call_status_id: 3,
    chk_tckt_open: false,
    delete_tbro: false,
    lat: 0,
    lng: 0,
    empid: empid,
    comments: '',
    os: 'Windows',
    build_version: '1.0.93',
    tbro_id: -1,
    AK: ak,
    modid: '9696',
    glid: glid,
    call_date: call_date,
    tbro_time: '',
    call_status_name: 'Talked and APPT',
    call_purpose_name: 'Others',
    call_service_name: '',
    attach_id: '',
    weberp_subject: weberp_subject,
    screen_name: `ContactCenterCRM`,
    additional_email_id: addition_email,
    video_meet: 1,
    video_meet_title: 'Video Meet With IndiaMART Team',
    video_meet_description: `<div><p><strong>Agenda for our Meeting:</strong></p><ul><li>Get More Relevant Buyleads</li><li>Improve Visibility of Top Products/Categories</li><li>Maximising Business Opportunities</li><li>Managing Business Leads Better</li><li>Don't Miss Buyer Call</li><li>Improve Business Rating</li></ul> We look forward to an interactive and productive session with you</div>`
  };

  const formData = new FormData();
  for (const key in requestData) {
    formData.append(key, requestData[key]);
  }
  return axios.post(apiUrl, formData);
}

export const getMeetingCode = (glid, empid, ak, callId) => {
  const apiURL = `${apiDomain}/getStsData?glid=${glid}&empid=${empid}&os=ANDROID&build_version=2024.09.02&vertical_id=40&AK=${ak}&build_version_code=146&type=VMC&platform=9696&call_id=${callId}&modid=9696`;
  return axios.get(apiURL);
}

//createSTS
export const createNewSTSID = async (empid, ak, insdata) => {
  const apiURL = `${apiDomain}/insertstsdata`
  const requestData = {
    "empid": empid,
    "AK": ak,
    "insdata": insdata
  }

  return await axios.post(apiURL, requestData)
}

// checkHotlead
export const checkHotlead = async (glid, empid, AK_token) => {
  const apiURL = `${apiDomain}/checkHotlead?glid=${glid}&empid=${empid}&AK=${AK_token}`;

  return axios.get(apiURL)
}

// apiAssigntoCompany
export const apiAssignToCompany = (glid, type) => {
  const apiURL = `${apiDomain}/apiassigntocompany?modid=9696&type=${type}&glid=${glid}`
  return axios.get(apiURL)
}

// Insert STS data
export const insertstsdata = (empid, ak, zip_code, city_id) =>{
  const apiURL = `${apiDomain}/Stsoperation/insertstsdata?empid=${empid}&AK=${ak}&operation=select&zip_code=${zip_code}&city_id=${city_id}`;
  return axios.get(apiURL);
}

// Update data in click_to_call table (insertclicktocall_get #01)
export const update_click_to_call_stsid = (empid, ak, crtObjectId, glid) => {
  if(crtObjectId !== '') {
    const apiURL = `${apiDomain}/callerdataupdation?empid=${empid}&AK=${ak}&ucid=${crtObjectId}&check=u&updateCheck=2&glid=${glid}`;
    return axios.get(apiURL)
  }
}

// insertactivity #01, ctcActivity
export const ctcActivity = (empid, ak, ucid, actID) => {
  if(ucid){
    const apiURL = `${apiDomain}/insertactivity?empid=${empid}&AK=${ak}&ucid=${ucid}&actid=${actID}`
    return axios.get(apiURL)
  }
}

// Insert data in click_to_call table
export const insertclicktocall = (empid, ak, crtObjId, check, updateCheck, condition) => {
  const apiURL = `${apiDomain}/callerdataupdation?empid=${empid}&AK=${ak}&ucid=${crtObjId}${condition}&check=${check}&updateCheck=${updateCheck}`;
  return axios.get(apiURL)
}

// Update STS
export const  updateSTS = (empid, ak, stsid,selected_empid,comments) => {
  const apiURL =`${apiDomain}/Stsoperation/insertstsdata?empid=${empid}&AK=${ak}&select_empid=${selected_empid}&stsid=${stsid}&comments=${comments}&operation=update`;
  return axios.get(apiURL)  
}

export const  updateSTSHistory = (empid, ak,comments,glid, mail_from, mail_from_name) => {
  const apiURL =`${apiDomain}/updatestshistory?AK=${ak}&comment=${comments}&empid=${empid}&glid=${glid}&mail_from=${mail_from}&mail_from_name=${mail_from_name}&modid=weberp&module_name=weberp&screen_name=9696&source_fns=14&sts_mail_flag=4&token=erp%4016072018&updated_by=${mail_from_name}`;
  return axios.post(apiURL)
}

export const get_scorecard_kpis = (glid,empid,ak, rptflag=0) => {
    if(glid){
        const apiUrl = `${apiDomain}/cust_scorecard_api`;
        const requestData = { "in_glusr_usr_id" : `${glid}`, "empid": `${empid}`, "AK": `${ak}`, "in_rpt_type": `${rptflag}` };
        return axios.post(apiUrl, requestData)
    }
}

export const get_topbar_summary = (glid,empid,ak) => {
    if(glid){
        const apiUrl = `${apiDomain}/gettopbarsmry`;
        const requestData = { "glUsrId" : `${glid}`, "empid": `${empid}`, "AK": `${ak}` };
        return axios.post(apiUrl, requestData)
    }
}


// Hotlead proc
export const hotlead_proc = (empid, ak, condition) => {
  const apiURL=`${apiDomain}/genHotLead?empid=${empid}&AK=${ak}${condition}&modid=9696`;
  return axios.get(apiURL);
} 

// Fetch Countries info
export const countriesInfo = (empid, ak, type, condition) => {
  const apiURL = `${apiDomain}/countiresInfo?&modid=9696&empid=${empid}&AK=${ak}&type=${type}${condition}`;
  return axios.get(apiURL)
}

export const nachHistories = (empid, glid, ak) => {
  const headers = {
    Authorization: `Bearer ${ak}`,
  };
  const apiURL = `${apiDomain}/nachHistory?empid=${empid}&selected_empid=${empid}&os=ANDROID&records=1&build_version=2024.05.28&vertical_id=35&build_version_code=139&platform=TeleM&modid=weberp&glid=${glid}&screen_name=9696`;
  
  return axios.get(apiURL, {headers})
}

// NACH Details API
export const nachDetails = (empid, ak, glid) => {
  if(empid && ak){
    const apiURL =  `${apiDomain}/ecsdetails?empid=${empid}&modid=weberp&screen_name=9696&AK=${ak}&glid=${glid}`;
    return axios.get(apiURL)
  }
}

// NACH STOP
export const nachStop = (requestData) =>{
  const apiUrl = `${apiDomain}/nachdeactivation`;
  return axios.post(apiUrl, requestData)
}

// Send Invoice
export const getInvoiceHtml = (glid, invoice_id, empid, ak) => {
  const apiUrl = `${apiDomain}/InvoiceHTMLReturn?glid=${glid}&invoiceId=${invoice_id}&empId=${empid}&other=1&AK=${ak}&modid=9696`;
  return axios.get(apiUrl);
}

export const recent_connects = (glid, days, empid, ak) => {
  const apiUrl = `${apiDomain}/recentConnects?glid=${glid}&days=${days}&empid=${empid}&AK=${ak}`;
  return axios.get(apiUrl);
}

// clickTocall inserts caller data into click_to_call table

export const clickToCall = async (empId, ak, crtObjectId, glid, callNo, dstPhone, custId, did, call_feedback) => {

  let vendorVal = '';

  if (dstPhone === '4845900' || dstPhone === '4845930') {
    vendorVal = 'iEnergizer';
  } else if (dstPhone === '918040246741') {
    vendorVal = 'Creative Lipi';
  } else if (dstPhone === '226719') {
    vendorVal = 'Competent';
  } else if (dstPhone === '226720') {
    vendorVal = 'Vkalp';
  } else if (dstPhone === '226721') {
    vendorVal = 'Live Digital';
  } else if (dstPhone === '226722') {
    vendorVal = 'Kochartech';
  } else {
    vendorVal = 'Creative Lipi';
  }

  const my_module = 'CALLCENTER';
  const flag_in_out = 'Incoming';
  let ref_no = 'LEAPIN';

  let callRecordingUrl = '';

  if (vendorVal === 'COGENTINBOUND') {
    callRecordingUrl = `http://182.75.225.82/indiamartib/${crtObjectId}.ogg`;
  } else if (vendorVal === 'Competent') {
    callRecordingUrl = `http://182.76.190.60:8080/${crtObjectId}.php`;
  } else if (vendorVal === 'Live Digital') {
    callRecordingUrl = `http://14.98.89.84/IndiaMart/${crtObjectId}.php`;
  } else if (vendorVal === 'Vkalp') {
    callRecordingUrl = `http://112.133.194.234:8082/IndiaMart/${crtObjectId}.php`;
  } else {
    callRecordingUrl = `http://crm.ienergizer.in:8040/recording.aspx?callkey=${crtObjectId}`;
  }

  if (dstPhone !== '') {
    ref_no = dstPhone.substring(0, 20);
  } else {
    ref_no = '';
  }

  const inputObject = {
    FLAG_IN_OUT: flag_in_out,
    CLIENT_MOB_NO: callNo,
    FK_EMPLOYEEID: empId,
    MODULE: my_module,
    REF_NO: ref_no,
    VENDOR: vendorVal,
    CALL_RECORDING_URL: callRecordingUrl,
    CUSTTYPE_ID: custId,
    CALL_FEEDBACK: call_feedback
  };

  const inputJson = JSON.stringify(inputObject);

  if (crtObjectId !== "" && did === null) {
    const apiURL = `${apiDomain}/callerdataupdation`
    const requestData = {
      "empid": empId,
      "AK": ak,
      "insdata": inputJson,
      "ucid": crtObjectId,
      "glid": glid,
      "check": "i"
    }

    return await axios.post(apiURL, requestData)
  }
}

export const invoice_history = async (glid, empid, ak) => {
  const apiUrl = `${apiDomain}/SellerInvoiceList?glid=${glid}&empId=${empid}&other=1&AK=${ak}&modid=9696`;
  return axios.get(apiUrl);
}

export const getAssigneeDetails = async (empid, ak, tkt_id, stsid, check) => {
  const apiUrl = `${apiDomain}/assigneedetails?empid=${empid}&AK=${ak}&ticketId=${tkt_id}&stsid=${stsid}&check=${check}`;
  return axios.get(apiUrl);
}

export const getVerticalId = async(empid, ak, glid) => {
  const apiUrl = `${apiDomain}/callerdataupdation?empid=${empid}&AK=${ak}&glid=${glid}&flag=vertical`;
  return axios.get(apiUrl);
}

export const getCreateOpportunity = async (empid, ak, glid, service_pitched, deal_amt, AutoDialerIVR, opportunity_name, inmcatlist="") => {
  const currTime = new Date();
  currTime.setDate(currTime.getDate() + 15); // Add 15 days
  const exp_closure = `${currTime.getDate().toString().padStart(2, '0')}-${currTime.toLocaleString('en-GB', { month: 'short' })}-${currTime.getFullYear().toString()}`;  //date format as 28-Nov-2024
  const apiUrl = `${apiDomain}/CreateOpportunity?empid=${empid}&AK=${ak}&glid=${glid}&service_pitched=${service_pitched}&opportunity_type=2&opportunity_stage=26&deal_amt=${deal_amt}&exp_closure=${exp_closure}&MODID=9696&is_hotlead=1&updated_by_screen=9696CRM&flag=1&AutoDialerIVR=${AutoDialerIVR}&opportunity_name=${opportunity_name}&inmcatlist=${inmcatlist}`;
  return axios.get(apiUrl);
}

export const fetchMcatlist = async (empid, ak, glid, service_pitched ) => {
  const apiUrl = `${apiDomain}/fetchMCATList?empid=${empid}&AK=${ak}&MODID=9696&glid=${glid}&service_pitched=${service_pitched}&payp_id=20`;
  return axios.get(apiUrl);
}

export const getNachDetails = async (empid, ak, glid) => {
  const apiUrl = `${apiDomain}/getnachdetails?empid=${empid}&AK=${ak}&glid=${glid}&modid=9696`;
  return axios.get(apiUrl);
} 

export const getSpamUserDetails = async (empid, ak, flag, fromDate, tillDate) => {
  const apiUrl = `${apiDomain}/spam-user-details?empid=${empid}&AK=${ak}&flag=${flag}&modid=9696&screen_name=CRM&fromDate=${fromDate}&tillDate=${tillDate}`;
  return axios.get(apiUrl);
}

export const unblockSpamUser = async (empid, ak, glid, flag, reason, ucid) => {
  const apiUrl = `${apiDomain}/spam-user-details`;
  const requestData = {
    "empid": empid,
    "AK": ak,
    "flag": flag,
    "glid": glid,
    "modid": "9696",
    "screen_name":"CRM",
    "reason": reason,
    "source": 9696,
    ...(ucid ? { ucid } : {})
  }
  return axios.post(apiUrl, requestData);
}

export const createTicket = async (requestData) => {
  const apiUrl = `${apiDomain}/createTicket`;
  return axios.post(apiUrl, requestData)
}

export const updateTicketDetails = async (requestData) => {
  const apiUrl = `${apiDomain}/updateticketdetails`;
  return axios.post(apiUrl, requestData)
}

export const fetcheEmployeeSearchDid = async (empid, ak, keyword) => {
  
  let config = {
    method: 'get',
    maxBodyLength: Infinity,
    url: `${apiDomain}/emp-search?modid=9696&screen=9696&empcheckbox=true&empid=${empid}&searchstring=${keyword}`,
    headers: { 
      'Authorization': `Bearer ${ak}`
    }
  };
  return axios.request(config);
}

export const whatsappCommunicationWrapper = async (requestData) => {
  const apiUrl = `${apiDomain}/whatsapp/communication_wrapper`;
  return axios.post(apiUrl, requestData)
}
